export const REASONING_STEPS_TEST_IDS = {
  container: 'reasoning-steps-container',
  statusRow: 'reasoning-steps-status-row',
  statusText: 'reasoning-steps-status',
  filterChipList: 'reasoning-steps-filter-chips',
  stepList: 'reasoning-steps-list',
  step: 'reasoning-steps-step',
  toolName: 'reasoning-steps-tool-name',
  separator: 'reasoning-steps-separator',
};
